import BrandProductSearch from "@client/components/Search/Pages/brand-product-search.class";

function init($views: HTMLElement[]) {
	const $module = $views[0];
	const search = new BrandProductSearch($module);

	search.search();
}

export default {
	view: "brand-product-searchPage",
	init,
};
